import { LogIn, ShieldAlert } from "lucide-react";
import { useEffect, useState } from "react";

export default function SessionExpiredOverlay() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handle = () => setVisible(true);
    window.addEventListener("session-expired", handle);
    return () => window.removeEventListener("session-expired", handle);
  }, []);

  if (!visible) return null;

  const handleLoginAgain = () => {
    const returnUrl = encodeURIComponent(
      window.location.pathname + window.location.search + window.location.hash,
    );
    window.location.replace(`/login?returnUrl=${returnUrl}`);
  };

  return (
    <div
      style={{ zIndex: 99999 }}
      className="fixed inset-0 flex items-center justify-center bg-black/50 backdrop-blur-sm"
    >
      <div className="bg-background border border-border rounded-2xl shadow-xl w-full max-w-md mx-4 p-10 flex flex-col gap-7">
        {/* Icon + text */}
        <div className="flex flex-col items-center gap-4 text-center">
          <div className="flex items-center justify-center w-11 h-11 rounded-xl bg-muted">
            <ShieldAlert className="w-5 h-5 text-foreground" />
          </div>
          <div>
            <h2 className="text-base font-semibold text-foreground">
              You've been signed out
            </h2>
            <p className="text-sm text-muted-foreground mt-1.5 leading-relaxed">
              Your session expired due to inactivity. Sign in again to continue.
            </p>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-border" />

        {/* Action */}
        <button
          onClick={handleLoginAgain}
          className="w-full flex items-center justify-center gap-2 py-2.5 px-4 rounded-lg text-sm font-medium text-white hover:opacity-90 transition-opacity active:scale-[0.98]"
          style={{
            background: "linear-gradient(135deg, #3b82f6 0%, #06b6d4 100%)",
          }}
        >
          <LogIn className="w-4 h-4" />
          Sign in again
        </button>
      </div>
    </div>
  );
}
